import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  eyebrow: string;
  title: ReactNode;
  subtitle?: ReactNode;
  /**
   * Deja el párrafo sin el tope de 560px. El diseño lo hace (`max-width: none`) en las
   * pantallas anchas, donde el subtítulo trae sus propios saltos de línea.
   */
  fullWidthSubtitle?: boolean;
}

/**
 * Replica el spec real de `.ph.ph-rule` de styles.css (sección "premium
 * fintech", la que gana en cascada): barra lateral de 2px en el color de
 * marca, eyebrow en el color de marca con punto+glow, h1 28px/600, párrafo
 * 15px gris.
 */
export const PageHeader = ({ eyebrow, title, subtitle, fullWidthSubtitle = false }: Props) => (
  <Box sx={{ mb: 2.5, borderLeft: "2px solid", borderColor: "primary.main", pl: "18px" }}>
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, mb: 1 }}>
      <Typography
        component="span"
        sx={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          // `text.eyebrow` de la marca; si no lo define, el color de marca (`--ld-blue`).
          color: (theme) => theme.palette.components?.text?.eyebrow ?? theme.palette.primary.main,
        }}
      >
        {eyebrow}
      </Typography>
    </Box>
    <Typography
      sx={{
        fontFamily: "Outfit",
        fontSize: 28,
        fontWeight: 600,
        letterSpacing: "-0.025em",
        lineHeight: 1.12,
        color: "primary.dark",
        mb: 1.25,
      }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        sx={{ fontSize: 15, color: "text.secondary", lineHeight: 1.55, maxWidth: fullWidthSubtitle ? "none" : 560 }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);
